// extracted by mini-css-extract-plugin
export default {"unrespondedMessageWrapper":"unrespondedMessageWrapper__OGYxY","unrespondedMessage":"unrespondedMessage__MjljM","withBanner":"withBanner__NTJlZ"};